<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <app-content-top-nav
            :mainItem="translations.list"
            :mainItemLink="{ name: 'epgs' }"
        />
        <show-language-select
            :allLanguages="!epgShow"
            :existingLanguagesIds="existingLanguagesIds"
            :selectedLanguageId="selectedLanguageId"
            @selectLanguage="onSelectLanguage"
            @addLanguage="createNewLanguageMutation"
        />
        <app-content-title :title="item.name || translations.newShow" :subTitle="appSubTitle" />
      </div>
      <app-tabs
          :colsTabs="columnTabs"
          :shouldLoadFirstTab="pending || !epgShow"
          :loadTab="params.tab"
          @appTabChanged="onAppTabChanged"
      >
        <div :title="translations.information">
          <sidebar
              epg-details
              :item="item"
              :show="epgShow || {}"
              :link-name="linkName"
              :selectedLanguageId="selectedLanguageId"
              :languageId="selectedLanguageId"
              @showSelected="onShowSelected"
              @moveAllExternalDataToShow="moveExternalData($event, false)"
              @moveExternalDataToShowEmptyFields="moveExternalData($event, true)"
              @moveOriginal="moveData($event, 'original')"
              @imagesChanged="imagesChanged"
          />
          <content-main>
            <form ref="formDom" @submit.prevent="onFormSubmit" :disabled="dataPending">
              <information-details
                  ref="infoDetails"
                  :item="epgShow || emptyShow"
                  isEpg
                  :pending="dataPending"
                  :errors-prop="errors"
                  :parentName="parentName"
                  :parentId="parentId"
                  :selectedShowLanguageId="selectedLanguageId"
                  @nameChange="linkName = $event"
              />
              <information-tags
                  ref="infoTags"
                  :formatLabels="formatLabels"
                  :contentLabels="contentLabels"
                  :countries="countries"
                  :pending="dataPending"
                  :errors-prop="errors"
                  @formatTagChanged="onFormatTagChanged"
                  @contentLabelsChanged="onContentLabelsChanged"
                  @contentCountriesChanged="onCountriesChanged"
              />
              <app-settings-buttons :navLinkTitle="translations.list" :navLinkTo="{ name: 'epgs' }">
                <app-content-save-button
                    :disabled="dataPending"
                    @click="disallowBack"
                />
              </app-settings-buttons>
            </form>
          </content-main>
        </div>
        <div
            :title="imagesHeader"
        >
          <h2 class="gallery_title">
            {{ imagesHeader }} - {{ showOrBroadcastName }}
          </h2>
          <images
              :item="epgShow || item"
              :parentName="parentName"
              :parentId="parentId"
          />
        </div>
        <div
            :title="translations.episodes"
            :data-disabled-title="translations.episodesSaveFirst"
            :data-disabled="!epgShow"
        >
          <episodes :item="epgShow || {}" />
        </div>
      </app-tabs>
    </form>
  </app-content>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import axios from 'axios'
import { processFormSubmit } from 'utils/form'
import Sidebar from 'components/Show/MainSidebar/index'
import ContentRoot from 'components/Show/Common/ContentRoot'
import ContentMain from 'components/Show/Common/ContentMain'
import InformationDetails from 'components/Show/Common/InformationDetails'
import InformationTags from 'components/Show/Common/InformationTags'
import Episodes from 'components/Show/Common/Episodes'
import Images from 'components/Show/Common/Images'
import ShowLanguageSelect from 'components/Show/Common/ShowLanguageSelect'
import { SHOW_TEMPLATE } from 'constants/showTemplate'
import appTitleMixin from 'mixins/appTitleMixin'
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import { setLoadingMessage, showErrorWithTimeout } from 'utils/form'
import { EPGS_SET_EPG_SHOW } from 'store/modules/epgs'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Epg'
})

export default {
  name: 'epg',
  mixins: [itemDetailMixin, appTitleMixin()],
  components: {
    Sidebar,
    ContentRoot,
    ContentMain,
    InformationDetails,
    InformationTags,
    Episodes,
    Images,
    ShowLanguageSelect
  },
  created() {
    this.selectedLanguageId = this.currentLanguageId
    this.fetchLabels()
    this.fetchCountries()
    this.params.tab = 0
  },
  data() {
    return {
      columnTabs: [
        0,
        2
      ],
      imagesUploading: false,
      linkName: null,
      selectedLanguageId: null,
      emptyShow: { ...SHOW_TEMPLATE },
      setterContentLabels: null,
      setterCountries: null,
      changedImages: []
    }
  },
  computed: {
    ...mapState({
      labels: state => state.labels.labels,
      states: state => state.countries.countries,
      labelsPending: state => state.labels.pending.labels,
      showPending: state => state.shows.pending.show,
      epgShow: state => state.epgs.epg.show,
      broadcastsPending: state => state.epgs.pending.broadcastAssign,
      currentLanguageId: state => state.uiLanguages.currentLanguageId
    }),
    translations() {
      return {
        list: this.$gettext('Seznam'),
        newShow: this.$gettext('Nový pořad'),
        information: this.$gettext('Informace'),
        episodes: this.$gettext('Epizody'),
        episodesSaveFirst: this.$gettext('Epizody (nutné uložit/zvolit pořad)')
      }
    },
    formatLabels() {
      if (!this.labels) {
        return {}
      }
      return this.labels
        .filter(v => v.type === 'LABEL_TYPE_FORMAT')
        .reduce((obj, v) => {
          obj[v._id] = {
            _id: v._id,
            name: v.labelName,
            checked: (this.epgShow && this.epgShow.formatLabelId === v._id) === true
          }
          return obj
        }, {})
    },
    countries() {
      if (this.setterCountries) {
        const countries = this.setterCountries
        this.setterCountries = null
        return countries
      }

      if (!this.states) {
        return []
      }

      const countries = this.states
      countries.forEach(item => {
        item['name'] = item['countryName']
        item['checked'] = (this.epgShow && this.epgShow.countryIds && this.epgShow.countryIds.includes(item._id)) || false
      })

      return countries
    },
    contentLabels() {
      if (this.setterContentLabels) {
        const contentLabels = this.setterContentLabels
        this.setterContentLabels = null
        return contentLabels
      }

      if (!this.labels) {
        return []
      }

      const contentLabels = this.labels.filter(v => v.type === 'LABEL_TYPE_CONTENT')
      contentLabels.forEach(item => {
        item['name'] = item['labelName']
        item['checked'] = (this.epgShow && this.epgShow.contentLabelIds && this.epgShow.contentLabelIds.includes(item._id)) || false
      })

      return contentLabels
    },
    appSubTitle() {
      if (!this.item.broadcast) {
        return ''
      }

      let str = ' | '
      const date = moment.unix(this.item.start)
      const endDate = date.clone().add(this.item.durationMinutes, 'minutes')
      str += date.format('ddd D. M. HH:mm') + '–' + endDate.format('HH:mm')
      str += `, ${this.item.tvStation.name}`

      return str
    },
    currentTitle() {
      return [
        { name: this.$gettext('Zpracování EPG'), link: { name: 'epgs' } },
        this.item.name || 'Vysílání'
      ]
    },
    dataPending() {
      return this.pending || this.labelsPending || this.showPending || this.broadcastsPending || this.imagesUploading
    },
    imagesHeader() {
      if (this.epgShow) {
        return this.$gettext('Obrázky k pořadu')
      } else {
        return this.$gettext('Obrázky k vysílání')
      }
    },
    showOrBroadcastName() {
      if (this.epgShow) {
        return this.epgShow.name
      } else {
        return this.item.name
      }
    },
    parentName() {
      if (this.pending) {
        return
      }

      if (this.epgShow) {
        return 'show'
      } else {
        return 'epg'
      }
    },
    parentId() {
      if (this.pending) {
        return
      }

      if (this.epgShow) {
        return this.epgShow._id
      } else {
        return this.item._id
      }
    },
    existingLanguagesIds() {
      if (this.epgShow) {
        return this.epgShow.existingLanguagesIds
      }
    }
  },
  methods: {
    ...mapActions([
      'getLabels',
      'getShow',
      'createShow',
      'updateShow',
      'getCountries',
      'assignBroadcasts',
      'getBroadcastOverview'
    ]),
    imagesChanged(images) {
      this.changedImages = images
    },
    onContentLabelsChanged(contentLabels) {
      this.setterContentLabels = contentLabels
    },
    onCountriesChanged(countries) {
      this.setterCountries = countries
    },
    fetchLabels() {
      this.getLabels({
        params: {
          idLanguage: this.currentLanguageId
        }
      })
    },
    fetchCountries() {
      this.getCountries({
        params: {
          idLanguage: this.currentLanguageId,
          order: '-weight'
        }
      })
    },
    onFormatTagChanged(id) {
      if (id !== null) {
        this.errors.remove('tagFormatId')
      }
    },
    onCountryChanged(id) {
      if (id !== null) {
        this.errors.remove('countryId')
      }
    },
    async onSelectLanguage(idLanguage) {
      this.selectedLanguageId = idLanguage

      let result = null
      if (this.epgShow) {
        result = await this.getShow({
          params: {
            id: this.epgShow._id,
            idLanguage: idLanguage
          }
        })
      }
      this.$store.commit({
        type: EPGS_SET_EPG_SHOW,
        show: result ? result.data.data : null
      })
    },
    createNewLanguageMutation(addedLanguage) {
      this.selectedLanguageId = addedLanguage._id
      this.$refs.infoDetails.createNewLanguageMutation()
    },
    async onFormSubmit(e) {
      this.errors.clear()

      const showData = {
        ...processFormSubmit(e),
        idLanguage: this.selectedLanguageId,
        contentLabelIds: this.contentLabels.filter(v => v.checked === true).map(v => v._id),
        countryIds: this.countries.filter(v => v.checked === true).map(v => v._id),
        importImages: this.changedImages
      }
      let show = null
      let response = null

      if (this.epgShow) {
        response = await this.updateShow({
          params: {
            id: this.epgShow._id
          },
          data: showData
        }).catch(err => err.response)
        this.apiErrors = response.data.error
        this.handleResponseIfError(response)
        show = this.epgShow
      } else {
        response = await this.createShow({
          data: showData
        }).catch(err => err.response)
        this.handleResponseIfError(response)

        if (response.status === 201) {
          show = response.data.data
        }
      }

      this.$store.commit({
        type: EPGS_SET_EPG_SHOW,
        show
      })

      const assignIds = this.$route.query.assign
      const assignArray = [this.item._id]
      if (assignIds) {
        assignArray.push(...assignIds.split(','))
      }

      await this.assignBroadcasts({
        data: {
          broadcastIds: assignArray,
          showId: show._id
        }
      })

      await this.getBroadcastOverview()

      if (this.backAllowed && this.apiErrors.length === 0) {
        this.goBack()
      }
    },
    setImagesUploading(uploading) {
      this.imagesUploading = uploading
      setLoadingMessage(this, uploading ? 'Nahrávání obrázků...' : null)
    },
    moveData(checkboxes, type) {
      const sourceData = { ...SHOW_TEMPLATE }

      Object.keys(checkboxes).filter(v => checkboxes[v].checked).forEach(v => {
        const checkbox = checkboxes[v]
        switch (v) {
          case 'name':
            if (checkboxes.name.value !== checkbox.value) { break }

            sourceData[v] = checkbox.value
            break
          case 'originalName':
            if (checkboxes.name.value !== checkbox.value) { break }
            sourceData[v] = checkbox.value
            break
          case 'country':
            if (!checkbox.value) break
            sourceData[v] = checkbox.value.replace(/ /g, '').split('/').join(', ')
            break
          case 'year':
            if (!checkbox.value) break
            if (!isNaN(checkbox.value)) {
              sourceData.yearStart = checkbox.value
            } else if (checkbox.value.includes('-')) {
              const parts = checkbox.value.replace(/ /g, '').split('-')

              sourceData.yearStart = parts[0]
              if (parts[1] && !isNaN(parts[1])) {
                sourceData.yearEnd = parts[1]
              } else {
                sourceData.yearEnd = moment().format('YYYY')
              }
            }
            break
          case 'duration':
            if (!checkbox.value) break
            sourceData[v] = checkbox.value.split(' min')[0]
            break
          case 'rating':
            if (checkbox.value && !isNaN(checkbox.value) && parseInt(checkbox.value, 10) !== 0) {
              const randNum = parseInt(checkbox.value, 10) + Math.round(Math.random() * 6) - 3
              if (randNum > 100) {
                sourceData[v] = 100
              } else if (randNum < 0) {
                sourceData[v] = 0
              } else {
                sourceData[v] = randNum
              }
            } else {
              sourceData[v] = Math.round(Math.random() * 10) + 60
            }
            break
          case 'directors':
            sourceData[v] = checkbox.value
            break
          case 'cast':
            sourceData[v] = checkbox.value
            break
          case 'description':
            if (!checkbox.value) break
            sourceData[v] = checkbox.value

            const descParts = checkbox.value.split('. ')
            sourceData[v] = descParts[0] + (descParts.length !== 1 ? '.' : '')
            break
          case 'description1': {
            if (!checkbox.value) break
            const desc1 = checkbox.value
            const desc2 = checkboxes.description2.value
            const desc1Parts = desc1.split('. ')
            const desc2Parts = desc2.split('. ')

            if (!checkboxes.descriptionLong.checked) {
              sourceData.description = desc1
              sourceData.leadParagraph = desc1Parts[0] + (desc1Parts.length !== 1 ? '.' : '')
            } else {
              if (desc1.length > desc2.length) {
                sourceData.description = desc1
                if (desc2Parts.length <= 2) {
                  sourceData.leadParagraph = desc2
                } else {
                  sourceData.leadParagraph = desc2Parts.slice(0, 2).join('. ') + '.'
                }
              } else {
                sourceData.description = desc2
                if (desc1Parts.length <= 2) {
                  sourceData.leadParagraph = desc1
                } else {
                  sourceData.leadParagraph = desc1Parts.slice(0, 2).join('. ') + '.'
                }
              }
            }
            break
          }
          case 'description2': {
            if (!checkbox.value) break
            const desc2 = checkbox.value
            const desc2Parts = desc2.split('. ')

            if (!checkboxes.descriptionShort.checked) {
              sourceData.description = desc2
              sourceData.leadParagraph = desc2Parts[0] + (desc2Parts.length !== 1 ? '.' : '')
            }
            break
          }
          case 'formatLabel': {
            for (const key in this.formatLabels) {
              if (this.formatLabels[key].name == checkboxes.formatLabel.value) {
                this.formatLabels[key].checked = true
              }
            }
            this.$refs.infoTags.filterAndSetFormatTag(this.formatLabels)
            break
          }
          case 'contentLabels': {
            const ids = checkboxes.contentLabels.value.split(',')
            for (const key in this.contentLabels) {
              this.contentLabels[key].checked = false
            }
            for (const key1 in this.contentLabels) {
              for (const key2 in ids) {
                if (this.contentLabels[key1].name == ids[key2]) {
                  this.contentLabels[key1].checked = true
                }
              }
            }

            this.$refs.infoTags.$forceUpdate()
            break
          }
        }
      }),
      this.$refs.infoDetails.copyFromSourceData(sourceData)
    },
    moveExternalData(data, onlyToEmpty) {
      if (this.selectedLanguageId !== null) {
        const sourceData = this.$refs.infoDetails.getShowData()
        const externalShowData = data.externalShowData
        const sourceDataToReplace = {}

        if (!onlyToEmpty) {
          sourceDataToReplace.csfdId = ''
          sourceDataToReplace.tmdbId = ''
          sourceDataToReplace.imdbId = ''
          sourceDataToReplace.name = ''
          sourceDataToReplace.originalName = ''
          sourceDataToReplace.rating = ''
          sourceDataToReplace.directors = ''
          sourceDataToReplace.cast = ''
          sourceDataToReplace.description = ''
          sourceDataToReplace.yearStart = ''
          sourceDataToReplace.yearEnd = ''
          sourceDataToReplace.duration = ''
          sourceDataToReplace.originalGenre = ''
          sourceDataToReplace.youtubeLink = ''
          sourceDataToReplace.leadParagraph = ''
          sourceDataToReplace.dataSource = ''
          sourceDataToReplace.isPeriodic = null
          this.$refs.infoTags.resetTagFormat()
          this.$refs.infoTags.removeAllContentLabels()
          this.$refs.infoTags.removeAllCountries()
        }

        if (data.id && data.type) {
          if (data.type == 'csfd') {
            sourceDataToReplace.csfdId = data.id
          } else if (data.type == 'tmdb') {
            sourceDataToReplace.tmdbId = data.id
          }
        }

        if (data.periodic !== null) {
          sourceDataToReplace.isPeriodic = data.periodic
        }

        if (data.durationInMinutes) {
          sourceDataToReplace.duration = data.durationInMinutes
        }

        Object.keys(externalShowData).forEach(fieldName => {
          const externalShowDataField = externalShowData[fieldName]

          if (!onlyToEmpty || !sourceData[fieldName]) {
            switch (fieldName) {
              case 'name':
              case 'originalName':
              case 'rating':
              case 'directors':
              case 'cast':
              case 'description':
                sourceDataToReplace[fieldName] = externalShowDataField.value
                break
              case 'year':
                if (!onlyToEmpty || !sourceData.yearStart) {
                  sourceDataToReplace.yearStart = externalShowDataField.value
                }
                break
            }
          }
        })

        this.$refs.infoDetails.copyFromExternalData(sourceDataToReplace)

        if (
          data.formatLabelId &&
          (!onlyToEmpty || this.$refs.infoTags.isTagFormatIdEmpty())
        ) {
          this.$refs.infoTags.setTagFormatId(data.formatLabelId)
        } else if (!onlyToEmpty) {
          this.$refs.infoTags.resetTagFormat()
        }

        if (
          data.contentLabelIds.length > 0 &&
          (!onlyToEmpty || this.$refs.infoTags.isContentLabelEmpty())
        ) {
          this.$refs.infoTags.removeAllContentLabels()
          data.contentLabelIds.forEach(contentLabelId => {
            this.$refs.infoTags.contentLabelSelected(contentLabelId)
          })
        } else if (!onlyToEmpty && data.contentLabelIds.length == 0) {
          this.$refs.infoTags.removeAllContentLabels()
        }

        if (
          data.countryIds.length > 0 &&
          (!onlyToEmpty || this.$refs.infoTags.isCountryEmpty())
        ) {
          this.$refs.infoTags.removeAllCountries()
          data.countryIds.forEach(countryId => {
            this.$refs.infoTags.countrySelected(countryId)
          })
        } else if (!onlyToEmpty && data.countryIds.length == 0) {
          this.$refs.infoTags.removeAllCountries()
        }
      } else {
        showErrorWithTimeout(this, this.$gettext('Nejprve přidejte jazyk.'))
      }
    },
    async onShowSelected(show) {
      let result = null
      if (show != null) {
        result = await this.getShow({
          params: {
            id: show._id,
            idLanguage: this.selectedLanguageId
          }
        })
      }
      this.$store.commit({
        type: EPGS_SET_EPG_SHOW,
        show: result ? result.data.data : null
      })
      if (this.epgShow) {
        this.selectedLanguageId = this.epgShow.selectedLanguageId
      }
    }
  },
  watch: {
    currentLanguageId() {
      this.fetchLabels()
      this.fetchCountries()
    },
    epgShow() {
      if (this.epgShow) {
        this.selectedLanguageId = this.epgShow.selectedLanguageId
      }
    }
  }
}
</script>
